import React from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_IMAGE_TEMPLATE_SCOPE } from '@/pages/ipe/workbench/utils/imageTemplateAccess';
import ImageTemplatePickerPanel from '@/pages/ipe/workbench/components/ImageTemplatePickerPanel';
import '@/styles/ipe/workbench/modals/ImageTemplatePickerModal.css';

export default function ImageTemplatePickerModal({
  isOpen,
  onCancel,
  onConfirm,
  groups = [],
  selectedGroup = '',
  onGroupChange,
  templates = [],
  selectedTemplateId,
  selectedTemplateIds = [],
  onSelectTemplate,
  onToggleTemplate,
  /** 详情页联动：底部展示已选图案/印花图 */
  selectedSources = null,
  title = '',
  confirming = false,
  /** 快捷 POD/选模板：展示个人 / 团队 / 官方 Tab */
  enableScopeTabs = false,
  canAccessTeamTemplates = false,
  initialScope = DEFAULT_IMAGE_TEMPLATE_SCOPE,
  /** 额外 class，如工作流编辑器内打开时增加顶距 */
  modalClassName = '',
  catalogsLoading = false,
}) {
  const { t } = useTranslation('workbench');
  const navigate = useNavigate();
  const heading = !title ? t('studioChrome.pickTitle') : title;
  const handleGoCreate = () => {
    onCancel?.();
    navigate('/ipe', { state: { activeNav: 'imageTemplates' } });
  };

  const sourceList = Array.isArray(selectedSources)
    ? selectedSources.filter((s) => s?.url || s?.previewUrl)
    : [];
  const showSourceStrip = sourceList.length > 0;

  if (!isOpen) return null;

  const modalRootClass = [
    'funding-modal',
    'funding-modal--top',
    'funding-modal--above-selection-bar',
    modalClassName,
  ].filter(Boolean).join(' ');

  const modalTree = (
    <div className={modalRootClass}>
      <div className="funding-modal__backdrop" role="presentation" />
      <div
        className={`funding-modal__panel funding-modal__panel--unified funding-modal__panel--image-template-picker${showSourceStrip ? ' funding-modal__panel--image-template-picker-with-sources' : ''}`}
        role="dialog"
        aria-modal="true"
      >
        <header className="funding-modal__header">
          <h3>{heading}</h3>
        </header>
        <div className="funding-modal__body">
          <ImageTemplatePickerPanel
            isActive={isOpen}
            groups={groups}
            selectedGroup={selectedGroup}
            onGroupChange={onGroupChange}
            templates={templates}
            selectedTemplateId={selectedTemplateId}
            selectedTemplateIds={selectedTemplateIds}
            onSelectTemplate={onSelectTemplate}
            onToggleTemplate={onToggleTemplate}
            selectedSources={selectedSources}
            confirming={confirming}
            enableScopeTabs={enableScopeTabs}
            canAccessTeamTemplates={canAccessTeamTemplates}
            initialScope={initialScope}
            onGoCreate={handleGoCreate}
            catalogsLoading={catalogsLoading}
          />
        </div>
        <footer className="funding-modal__footer">
          <button
            type="button"
            className="funding-button funding-button--ghost"
            onClick={onCancel}
            disabled={confirming}
          >
            {t('studioChrome.cancel')}
          </button>
          <button
            type="button"
            className="funding-button funding-button--accent"
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? t('studioChrome.importing') : t('studioChrome.confirmImport')}
          </button>
        </footer>
      </div>
    </div>
  );

  if (typeof document !== 'undefined') {
    return createPortal(modalTree, document.body);
  }

  return modalTree;
}
